<script setup lang="ts">
import { SharedData } from '@/@types'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet'
import { Link, usePage } from '@inertiajs/vue3'
import { Menu } from 'lucide-vue-next'

const { user } = usePage<SharedData>().props
</script>

<template>
    <div class="flex lg:hidden">
        <Sheet>
            <SheetTrigger>
                <Menu />
                <span class="sr-only">Abrir menu</span>
            </SheetTrigger>
            <SheetContent>
                <SheetHeader>
                    <SheetTitle>Menu</SheetTitle>
                    <SheetDescription>
                        <ul class="text-foreground flex flex-col gap-4">
                            <li>
                                <Link href="/">{{ $t('Home') }}</Link>
                            </li>
                            <li>
                                <Link href="/#tickets">{{ $t('Buy tickets') }}</Link>
                            </li>  
                            <template v-if="user">
                                <li>
                                    <Link href="/orders">{{ $t('My orders') }}</Link>
                                </li>
                                <li v-if="user.active_for_invited">
                                    <Link href="/participant/mailings">{{ $t('My ticket') }}</Link>
                                </li>
                                <template v-if="user.role == 'admin'">
                                    <li>
                                        <Link href="/coupons">{{ $t('Manage coupons') }}</Link>
                                    </li>
                                    <li>
                                        <Link href="/admin/orders">{{ $t('Manage orders') }}</Link>
                                    </li>
                                    <li>
                                        <Link href="/admin/reports/sellers">Relatórios</Link>
                                    </li>
                                </template>
                            </template>
                        </ul>
                    </SheetDescription>
                </SheetHeader>
            </SheetContent>
        </Sheet>
    </div>
</template>
